import { motion } from 'framer-motion';
import React from 'react';


export default function Loader() {

    const LodeerVariant = {
        animationOne: {
            rotate: [0, -360],
            transition: {
                rotate: {
                    yoyo: Infinity,
                    duration: 0.5
                },
            }
        }
    };
    return (
        <motion.div className="loader"
        animate={{y:"150%"}}
        transition={{duration:1 ,delay:1}}
        >
            <motion.div
                variants={LodeerVariant}
                animate="animationOne"
            ></motion.div>
        </motion.div>
    )
}
